import documentTitle from '../../data-organizers/documents/documentTitle'
import { journalMessage, journalSeverity } from './journalMessage'

// The image's four-image class rendered as a Hebrew label. An image gets a label,
// not a deep link — the record points at the image, but the user navigates to its
// owning entry/document instead.
const imageClassLabels = {
    Check_Front_tif: 'שיק — קדמי TIF',
    Check_Back_tif: 'שיק — אחורי TIF',
    Check_Front_jpg: 'שיק — קדמי JPG',
    Check_Back_jpg: 'שיק — אחורי JPG',
    Voucher_Front_tif: 'שובר — קדמי TIF',
    Voucher_Back_tif: 'שובר — אחורי TIF',
    Voucher_Front_jpg: 'שובר — קדמי JPG',
    Voucher_Back_jpg: 'שובר — אחורי JPG',
}

function imageClassLabel(type) {
    return imageClassLabels[type] ?? type
}

/**
 * Resolves a user-visible journal record into the pieces the transparency page
 * renders: its message, and the concrete company/entry/document it involves
 * (derived up the image→document→entry→company chain when the record points at a
 * deeper entity). The image itself becomes a class label rather than a link.
 */
export function resolveJournalRow(record) {
    const image = record.images?.[0] ?? null
    const document = record.documents?.[0] ?? image?.document ?? null

    // The document link rests on the document's own entry and that entry's company
    // — never the journal's directly-linked entry, which may belong to something
    // unrelated. Each is populated up its own chain in the fetch.
    const documentEntry = document?.entry ?? null
    const documentCompany = documentEntry?.company ?? null

    // The entry link uses the journal's directly-linked entry, falling back to the
    // entry the document/image chain rests on.
    const entry = record.entries?.[0] ?? documentEntry ?? null
    const company = entry?.company ?? null

    const documentLabel = document != null ? documentTitle(document) : null
    const imageLabel = image != null ? imageClassLabel(image.type) : null
    const batch = record.batches?.[0] ?? null

    // A flat text summary of the items, so the column sorts and the search box
    // matches on the same text the cell renders.
    const subject = [
        entry != null ? `רשומה ${entry.id}` : null,
        documentLabel,
        imageLabel,
        batch != null ? `שידור ${batch.id}` : null,
    ].filter((part) => part != null).join(' ')

    return {
        message: journalMessage(record),
        type: record.type,
        severity: journalSeverity(record.type),
        createdAt: record.createdAt,
        parentId: record.parent?.id ?? null,
        company,
        companyName: company?.companyName ?? '',
        entry,
        document,
        documentEntry,
        documentCompany,
        documentLabel,
        imageLabel,
        batch,
        subject,
    }
}
